module.exports = __webpack_public_path__ + "static/tint-2-2c56a7decdd5dd31485267501f4daf92.jpg";